<template lang="html">
  <div>
    <modal class="usdt-addresses-window" :name="usdtAddressesModalName" :adaptive="true" width="850" height="auto" :clickToClose="true">
      <div class="usdt-addresses-window-content">
        <div class="window-content-header">
          <div class="title v-centered">
            <h2>{{$t('USDT Tether адреса')}}</h2>
          </div>
          <div class="control v-centered" v-click-outside="hidePopoverNewAddress">
            <template v-if="showAddButton"><a class="add-crypto-address-btn" href="#" @click.prevent="onClickAddAddressBtn"><i class="capitalist-icon-plus-rounded"></i>{{$t('Новый адрес')}}</a></template>
            <template v-if="isCreating">
              <div class="btn-generating-text">{{$t('Генерируется адрес...')}}</div>
            </template>
            <div class="popover-newaddress" v-show="popoverNewAddressVisible">
              <h3>{{$t('Выберите сеть')}}:</h3>
              <ul class="choose-usdt-network">
                <li class="erc20" v-show="showEthereum"><a href="#" @click.prevent="selectEthereum">
                  <div class="usdt-network">
                    <div class="usdt-net-icon"><img src="./usdt/ethereum-circle.svg" width="22" height="22" alt="Erc20"/></div><span>Ethereum (ERC20)</span>
                    <div><img src="./usdt/check.svg" width="10" height="6" v-if="isSelectedEthereum"/></div>
                  </div></a></li>
                <li class="trc20" v-show="showTron"><a href="#" @click.prevent="selectTron">
                  <div class="usdt-network">
                    <div class="usdt-net-icon"><img src="./usdt/tron.svg" width="22" height="22" alt="Erc20"/></div><span>Tron (TRC20)</span>
                    <div><img src="./usdt/check.svg" width="10" height="6" v-if="isSelectedTron"/></div>
                  </div></a></li>
              </ul>
              <button class="create-address btn btn-success-outline" @click.prevent="createAddress" :disabled="isCreating">
                <template v-if="!isCreating">{{$t('Создать адрес')}}</template>
                <template v-if="isCreating">{{$t('Создается адрес')}}...</template>
              </button>
            </div>
          </div>
          <div></div>
          <div class="close-control"><a href="#" @click.prevent="closeModal"><img src="./closemodal.svg" width="15" height="15" alt="Close modal"/></a></div>
        </div>
        <div class="alert-warning">
          <p v-if="showTron && showEthereum">{{$t('hint.line1_both')}}</p>
          <p v-if="showTron">{{$t('hint.line1_tron')}}</p>
          <p v-if="showEthereum">{{$t('hint.line1_ethereum')}}</p>
          <p>{{$t('hint.line2')}}</p>
          <p>{{$t('hint.line3')}}</p>
        </div>
        <template v-if="isLoaded">
          <template v-if="hasAddresses">
            <template v-if="allAddressesAreHidden">
              <div class="all-addresses-are-hidden">
                <p>{{$t('Все адреса скрыты.')}}</p><a class="btn btn-success" @click.prevent="showHidden = true">{{$t('Показать все')}}</a>
              </div>
            </template>
            <template v-else>
              <div class="scrollable-wrapper">
                <div class="crypto-addresses-table">
                  <div class="crypto-addresses-table__thead">
                    <div>{{$t('Название')}}</div>
                    <div>{{$t('Адрес')}}</div>
                    <div>&nbsp;</div>
                    <!--div &nbsp;-->
                  </div>
                  <crypto-address-table-row :address="address" @update-address="onAddressUpdate" @start-edit="onStartEdit(address)" :key="'usdt-row-address-' + address.id" v-for="address in filteredAddresses"></crypto-address-table-row>
                </div>
              </div>
            </template>
            <div class="crypto-addresses-table__after" v-if="hasHiddenAddresses && !allAddressesAreHidden">
              <div><a href="#" @click.prevent="showHidden = !showHidden">
                <template v-if="!showHidden">{{$t('Показывать скрытые адреса')}}</template>
                <template v-else>{{$t('Не показывать скрытые адреса')}}</template></a></div>
            </div>
          </template>
          <template v-if="!hasAddresses"><br/>
            <p class="text-center">{{$t('У вас еще нет ни одного адреса USDT Tether.')}}</p>
          </template>
        </template>
        <template v-if="isReloading">
          <div class="addresses-loader-wrapper">
            <circle-loader>{{$t('Загружается список адресов...')}}</circle-loader>
          </div>
        </template>
      </div>
    </modal>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import VModal from 'vue-js-modal';
import ClickOutside from 'vue-click-outside/index.js';
import CircleLoader from '@/components/loaders/CircleLoader.vue';
import {
  CryptoAddress,
  UsdtAddressesModel,
  UsdtCryptoAddressCreateModel,
  UsdtNetworkType,
} from '@/models/finance/crypto';
import CryptoAddressTableRow from '@/views/pages/finance/accounts/crypto/usdt/CryptoAddressTableRow.vue';
import DropdownCryptoAddresses from '@/components/forms/dropdown/DropdownCryptoAddresses.vue';
import {CurrencyCode} from '@/models/core/currency';

Vue.use(VModal);

@Component({
  name: 'usdt-addresses-window',
  components: {DropdownCryptoAddresses, CryptoAddressTableRow, CircleLoader},
  directives: {ClickOutside},
})
export default class UsdtAddressesWindow extends Vue {
  model: UsdtAddressesModel = new UsdtAddressesModel();

  @Prop({default: CurrencyCode.USDT})
  currency!: CurrencyCode

  showHidden = false;

  onClickAddAddressBtn() {
    // this.togglePopoverNewAddress();
    this.createAddress();
  }

  get showAddButton() {
    return this.isLoaded && !this.isCreating;
  }

  get showTron() {
    return this.currency === CurrencyCode.USDTt;
  }

  get showEthereum() {
    return this.currency === CurrencyCode.USDT;
  }

  onStartEdit(address: CryptoAddress) {
    return null;
  }

  get allAddressesAreHidden() {
    return this.filteredAddresses.length == 0;
  }

  usdtAddressesModalName = (function () {
    return `usdtAddressesModal_${Math.random().toString(36).substr(2, 9)}`;
  }());

  onAddressUpdate(address: CryptoAddress) {
    this.updateAddress(address);
  }

  mounted() {
    this.model.loadAddresses(this.currency);
  }

  get prefilteredAddresses() {
    if (!this.isLoaded) return [];

    return this.model.addresses.filter((address: CryptoAddress) => address.currency === this.currency);
  }

  get filteredAddresses() {
    if (!this.hasAddresses) return [];

    if (this.showHidden) return this.prefilteredAddresses;

    return this.prefilteredAddresses.filter((address: CryptoAddress) => !address.hidden);
  }

  get isReloading() {
    return !this.model.loadingState.isLoaded;
  }

  get isLoaded() {
    return this.model.loadingState.isLoaded;
  }

  get hasAddresses() {
    return this.isLoaded && this.prefilteredAddresses.length > 0;
  }

  openModal(openNetworkSelect = false) {
    this.selectedNetwork = this.showEthereum ? UsdtNetworkType.Ethereum : UsdtNetworkType.Tron;
    this.$modal.show(this.usdtAddressesModalName);
    Vue.nextTick(() => {
      if (openNetworkSelect) {
        this.showPopoverNewAddress();
      }
    });
  }

  closeModal() {
    this.$modal.hide(this.usdtAddressesModalName);
  }

  popoverNewAddressVisible = false;

  selectedNetwork = UsdtNetworkType.Ethereum;

  createModel: UsdtCryptoAddressCreateModel = new UsdtCryptoAddressCreateModel();

  get isCreating() {
    return this.createModel.state.isLoading;
  }

  get isSelectedEthereum() {
    return this.selectedNetwork === UsdtNetworkType.Ethereum;
  }

  get isSelectedTron() {
    return this.selectedNetwork === UsdtNetworkType.Tron;
  }

  selectTron() {
    this.selectedNetwork = UsdtNetworkType.Tron;
  }

  selectEthereum() {
    this.selectedNetwork = UsdtNetworkType.Ethereum;
  }

  showPopoverNewAddress() {
    this.popoverNewAddressVisible = true;
  }

  hidePopoverNewAddress() {
    this.popoverNewAddressVisible = false;
  }

  togglePopoverNewAddress() {
    this.popoverNewAddressVisible = !this.popoverNewAddressVisible;
  }

  get hasHiddenAddresses() {
    if (!this.hasAddresses) return false;
    for (const address of this.model.addresses) if ((address as any).hidden) return true;
    return false;
  }

  updateAddress(address: CryptoAddress) {
    this.model.updateAddress(address);
    this.$emit('update-addresses', this.model.addresses);
  }

  createAddress() {
    if (this.isCreating) return;
    this.createModel.createAddress(this.selectedNetwork)
        .then((address: CryptoAddress) => {
          this.updateAddress(address);
          this.hidePopoverNewAddress();
        }).catch((err) => {
      throw err;
    });
  }
}
</script>

<style scoped lang="less">
.btn-generating-text {
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

.usdt-addresses-window {
  .scrollable-wrapper {
    max-height: 50vh;
    overflow-y: auto;
    overflow-x: hidden;
    margin-top: 15px;
    margin-bottom: 15px;

    &:hover {
      &::-webkit-scrollbar {
        opacity: 1;
      }
    }

    &::-webkit-scrollbar {
      width: 8px;
      opacity: 0.7;
    }

    &::-webkit-scrollbar-track {
      //box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      background-color: #d3e0cc;
      border-radius: 3px;
      width: 8px;
      margin-left: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #71a719;
      outline: 1px solid #71a719;
      border-radius: 3px;
    }
  }

  .addresses-loader-wrapper {
    margin: 50px 50px;
    align-items: center;
    justify-content: center;
    display: flex;

    ::v-deep {
      .circle-loader {
        width: 40px;
        height: 40px;
        border-width: 2px;
      }
    }
  }

  .all-addresses-are-hidden {

    .subtitle {

    }

    p {
      font-size: 120%;
    }

    text-align: center;
    margin: 30px;
  }

  ::v-deep {
    .vm--modal {
      border-radius: 5px;
      overflow: visible;
    }
  }

  h2 {
    font-style: normal;
    font-weight: 600;
    font-size: 32px;
    line-height: 32px;
    /* identical to box height, or 49px */
    color: #333333;
    margin: 0;
    padding: 0;
  }

  .alert-warning {
    background: #FFFCE5;
    border: 1px solid #F6EABF;
    box-sizing: border-box;
    border-radius: 2px;
    padding: 10px 20px;

    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 21px;
    color: #8A8A96;
    border-radius: 5px;

    margin-top: 20px;

    p {
      margin: 0;
      padding: 0;
    }
  }

  .usdt-addresses-window-content {
    padding: 30px 40px;

    .window-content-header {
      display: grid;
      grid-gap: 40px;
      grid-template-columns: max-content max-content auto min-content;

      .control {
        position: relative;
      }

      > .v-centered {
        align-self: center;
      }
    }
  }
}

.crypto-addresses-table__after {
  text-align: right;

  a {
    font-size: 90%;
    border-bottom: 1px dashed green;
  }

  margin-bottom: 30px;
}

.crypto-addresses-table {

  margin-top: 15px;
  margin-bottom: 15px;

  display: grid;
  grid-gap: 10px 0;
  grid-template-columns: max-content auto min-content;

  &__thead {
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 16px;
    /* identical to box height, or 123% */
    color: #BDBDBD;
  }

  .crypto-addresses-table__thead {
    div {
      border-bottom: 2px solid #E9E9E9;
    }

  }

  ::v-deep {

    .crypto-addresses-table__thead,
    .crypto-addresses-table__row {
      display: contents;

      > div {
        padding: 3px 25px 10px 0;
        border-bottom: 1px solid #E9E9E9;
      }
    }
  }
}

.popover-newaddress {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 15px;
  display: block;
  width: auto;

  h3 {
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 18px;
    margin: 0;
    padding: 0;
    color: #333333;
  }

  background: #FFFFFF;
  border: 1px solid #EAEBF3;
  box-sizing: border-box;
  box-shadow: 0px 16px 32px rgba(9, 9, 9, 0.12);
  border-radius: 6px;
  padding: 30px;

  .create-address {
    color: #000;
    font-size: 14px;

    &:hover {
      color: #fff;
    }
  }

  ul.choose-usdt-network {
    margin: 25px 0 30px 0;
    min-width: 200px;

    li {
      margin: 5px -15px 10px -15px;
      padding: 0;

      a {
        display: block;

        &:hover {
          background: #effade;
        }

        padding: 5px 15px;
        border-radius: 4px;

        > div {
          display: grid;
          grid-gap: 15px;
          grid-template-columns: min-content auto min-content;
          align-items: center;
          word-break: normal;
          white-space: nowrap;
        }
      }
    }
  }

}
</style>

<i18n>
{
  "en": {
    "hint": {
      "line1_both": "Please note that ONLY direct payments from USDT Tether (ERC20) or USDT Tether (TRC20) addresses are accepted for these details.",
      "line1_ethereum": "Please note that ONLY direct payments from USDT Tether (ERC20) addresses are accepted for these details.",
      "line1_tron": "Please note that ONLY direct payments from USDT Tether (TRC20) addresses are accepted for these details.",
      "line2": "The minimum deposit amount is 5 USDT. In case of sending a transfer of less than 5 USDT, funds will not be credited to the Capitalist account.",
      "line3": "In case of incorrectly specified data, the search fee will be 10% of the payment amount."
    },
    "Загружается список адресов...": "Loading addresses list...",
    "USDT Tether адреса": "USDT Tether addresses",
    "Новый адрес": "New address",
    "Выберите сеть": "Select network",
    "Создается адрес": "Address is creating",
    "Создать адрес": "Create address",
    "Название": "Name",
    "Адрес": "Address",
    "Идет процесс создания...": "New address is creating...",
    "Все адреса скрыты.": "All addresses are hidden.",
    "Показывать скрытые адреса": "Show hidden addresses",
    "Не показывать скрытые адреса": "Do not show hidden addresses",
    "Показать": "Show",
    "Показать все": "Show all",
    "У вас еще нет ни одного адреса USDT Tether.": "You have no one USDT Tether address.",
    "Генерируется адрес...": "Address is generating..."
  },
  "ru": {
    "hint": {
      "line1_both": "Обращаем Ваше внимание, на данные реквизиты принимаются ТОЛЬКО прямые платежи с кошельков USDT Tether (ERC20) или USDT Tether (TRC20).",
      "line1_ethereum": "Обращаем Ваше внимание, на данные реквизиты принимаются ТОЛЬКО прямые платежи с кошельков USDT Tether (ERC20).",
      "line1_tron": "Обращаем Ваше внимание, на данные реквизиты принимаются ТОЛЬКО прямые платежи с кошельков USDT Tether (TRC20).",
      "line2": "Минимальная сумма пополнения 5 USDT. В случае отправки перевода на сумму менее 5 USDT средства не будут зачислены на счет Capitalist.",
      "line3": "В случае некорректно указанных данных комиссия за поиск составит 10% от суммы платежа."
    }
  }
}
</i18n>
